import Illustration from "@portal/components/atoms/illustrations";

export const GetIconForExperiencePage = (index: number) => {
  const size = "xxlarge";
  if (index === 0) return <Illustration name={"womanWithCatYellowIcon"} size={size} />;
  if (index === 1) return <Illustration name={"womanWithPhoneAndNatureYellowIcon"} size={size} />;
  if (index === 2) return <Illustration name={"manConfirmingYellowIcon"} size={size} />;
};
